import { loading } from '@/common/loading'
import { getTaskListSH, modifyIfJcdApp} from '@/api/baseMsg'
import { Toast } from "vant";
import previewPDF from "@/components/previewPDF/index";
import config from '@/config/index'
import axios from "axios";
export default {
  name: "examine",
  components:{
    previewPDF
  },
  data() {
    return {
      option: [],
      List: [],
      query: {
        taskCode: '',
        taskName: '',
        exeno: ''
      },
      dropdownTitle: "", //下拉展示标题
      dropdownInput: "", //搜索筛选框
      inputTable: [], //新数组作为筛选存储数组
      showDrop: false, //展示drop标记
      tableList: []
    }
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    init() {
      loading(true);
      this.handQuery()
    },
    handQuery() {
      const params = {
        taskName: '',
      }
      getTaskListSH(params).then(res=> {
        if(res.code == 200) {
          res.data.forEach(i=> {
            i.if_jcd_app = i.if_jcd_app ? true : false
          })
          this.List = res.data
        }
        loading(false);
      })
      
    },
    onClickLeft () {
        this.$router.push('/');
    },
    onInput(item) {
      this.$dialog.confirm({
        title: '提醒',
        message: '是否修改此任务的app是否显示监测点？',
      }).then(() => {
        loading(true)
        modifyIfJcdApp({
          id: item.id,
          ifJcdApp: item.if_jcd_app ? 0 : 1
        }).then(res=> {
          if(res.code == 200) {
            Toast.success('操作成功！')
            this.handQuery()
          }
        })
      });
    },
  }
} 